import { boolean, RequestKind } from '@sb/library/base';
import { EmailAddressVerificationConfirmationItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace EmailAddressVerificationRoutes {
    export const Confirm = ApiRoute.Define({
        URL: 'email-address-verifications/confirm',
        Kind: RequestKind.Post,
        BodyType: EmailAddressVerificationConfirmationItem,
        ResultType: boolean
    });
}
